import { APIEncryptor } from 'app/runtime';
import axios from 'axios';
import { ResultType } from 'services/CommonDT';
import { bizBaseUrl } from 'services/request';

import AES from 'crypto-js';
const key = AES.enc.Utf8.parse(APIEncryptor.key); //十六位十六进制数作为密钥
const iv = AES.enc.Utf8.parse(APIEncryptor.iv); //十六位十六进制数作为密钥偏移量

// mode: AES.mode.CBC 必须设置偏移码iv
// iv,
// mode: AES.mode.CBC,
// mode: AES.mode.ECB 可以不设置

// 加密
const encrypt = (word: any, en2ciphertext = true) => {
  word = AES.enc.Utf8.parse(word);
  const encrypted = AES.AES.encrypt(word, key, {
    mode: AES.mode.ECB,
    padding: AES.pad.Pkcs7,
  });
  if (en2ciphertext) {
    // 把base64转为ciphertext(不区分大小写), 和后端不和(后端使用base64)
    return encrypted.ciphertext.toString().toUpperCase();
  } else {
    return encrypted.toString();
  }
};

// 解密
const decrypt = (word: any, en4ciphertext = true) => {
  const encryptedHexStr = AES.enc.Hex.parse(word);
  if (en4ciphertext) {
    // 从base64转为ciphertext(不区分大小写), 和后端不和(后端本来就是base64)
    word = AES.enc.Base64.stringify(encryptedHexStr);
  }
  const decrypted = AES.AES.decrypt(word, key, {
    mode: AES.mode.ECB,
    padding: AES.pad.Pkcs7,
  });
  return decrypted.toString(AES.enc.Utf8).toString();
};

const encryptObj = (word: any, en4ciphertext = true) => {
  return encrypt(JSON.stringify(word), en4ciphertext);
};
const decryptObj = (word: any, en4ciphertext = true) => {
  return JSON.parse(decrypt(word, en4ciphertext));
};

const test = (content: any) => {
  console.info('原文', content);
  console.info('加密', encrypt(content));
  console.info('解密', decrypt(encrypt(content)));
};
const testStr = () => {
  console.info('========testStr==========');
  const content = 'new Array(3).fill(0)';
  // const contentJson: any = JSON.stringify(content);
  console.info('原文', content);
  // 字符串没必要json化
  // console.info("原文json化", contentJson);
  console.info('对原文加密', encrypt(content));
  // console.info("对json加密", encrypt(contentJson));
  console.info('解密原文', decrypt(encrypt(content)));
  // console.info("解密json", decrypt(encrypt(contentJson)));
  // 字符串json化后无法转回
  // console.info("解密-逆json", JSON.parse(decrypt(encrypt(contentJson))));
};
const testArr = () => {
  console.info('========testArr==========');
  const content = new Array(3).fill(0);
  const contentJson: any = JSON.stringify(content);
  console.info('原文', content);
  console.info('原文json化', contentJson);
  // 非字符串格式无法加密
  // console.info("对原文加密", encrypt(content));
  // console.info("对json加密", encrypt(contentJson));
  console.info('对json加密', encryptObj(content));
  // console.info("解密原文", decrypt(encrypt(content)));
  // console.info("解密json", decrypt(encrypt(contentJson)));
  console.info('解密json', decryptObj(encryptObj(content)));
  // console.info("解密-逆json", JSON.parse(decrypt(encrypt(contentJson))));
};
const testObj = () => {
  console.info('========testObj==========');
  const content = { username: 'admin', age: 12 };
  const contentJson: any = JSON.stringify(content);
  console.info('原文', content);
  console.info('原文json化', contentJson);
  // console.info("对原文加密", encrypt(content));
  // console.info("对json加密", encrypt(contentJson));
  console.info('对json加密', encryptObj(content));
  // console.info("解密原文", decrypt(encrypt(content)));
  // console.info("解密json", decrypt(encrypt(contentJson)));
  console.info('解密json', decryptObj(encryptObj(content)));
  // console.info("解密-逆json", JSON.parse(decrypt(encrypt(contentJson))));
};
const testDemo = () => {
  console.info('========testDemo==========');
  const fetch = async () => {
    const encryptData: ResultType = (await axios.get(bizBaseUrl + '/encrypt')).data;
    const decryptData = decrypt(encryptData.result, false);
    const encryptData2 = encrypt(decryptData, false);
    const decryptData2 = (
      await axios.request({
        url: bizBaseUrl + '/decrypt',
        method: 'post',
        data: encryptData2,
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        // 禁止 Axios自动将 JavaScript 对象转换为 JSON 字符串 的默认行为
        transformRequest: [
          (data, headers) => {
            return data;
          },
        ],
      })
    ).data;
    console.info('encryptData', encryptData);
    console.info('decryptData', decryptData);
    console.info('encryptData2', encryptData2);
    console.info('decryptData2', decryptData2);
  };
  fetch();
};

const AesUtil = {
  encrypt,
  decrypt,
  encryptObj,
  decryptObj,
  test,
  testStr,
  testArr,
  testObj,
  testDemo,
};

export default AesUtil;
